import * as Sentry from '@sentry/browser'

export default error => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(error)
  }

  Sentry.captureException(error)
}
